import { render } from "./categories-section.vue?vue&type=template&id=4ba1aa73"
import script from "./categories-section.vue?vue&type=script&lang=js"
export * from "./categories-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__